// extracted by mini-css-extract-plugin
export default {"triangleDown":"categoryButton-style_triangleDown__fZOah","triangleUp":"categoryButton-style_triangleUp__FFbgu"};